// auth.interceptor.ts
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from './auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth   = inject(AuthService);
  const router = inject(Router);
  const token  = auth.getToken();

  // Token anhängen wenn vorhanden
  if (token) {
    req = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` }
    });
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {

      if (error.status === 401) {

        // Login-Request selbst ausnehmen —
        // sonst würde ein falsches Passwort auch ausloggen
        const isLoginRequest = req.url.includes('/login');

        if (!isLoginRequest) {
          auth.logout();                           // Token löschen
          router.navigate(['/login'], {
            queryParams: { reason: 'session_expired' }  // ← Grund mitgeben
          });
        }
      }

      return throwError(() => error);  // ← Fehler weitergeben damit der Component ihn behandeln kann
    })
  );
};
